import PubSub from './pubsub';

export default class Store {
    constructor(params) {
        let self = this;
        self.actions = {};
        self.mutations = {};
        self.state = {};
        self.status = 'default state';
        self.events = new PubSub();

        // Initialize mutations first
        if (params.hasOwnProperty('mutations')) {
            self.mutations = params.mutations;
        }

        // Initialize actions
        if (params.hasOwnProperty('actions')) {
            // Bind actions to store instance
            self.actions = Object.keys(params.actions).reduce((acc, key) => {
                acc[key] = params.actions[key].bind(null, {
                    commit: this.commit.bind(this),
                    state: this.state
                });
                return acc;
            }, {});
        }

        // Initialize state with proxy
        self.state = new Proxy((params.state || {}), {
            set: function (state, key, value) {
                const isMutation = self.status === 'mutation';
                state[key] = value;
                console.log(`stateChange: ${key}:`, value);
                self.events.publish('stateChange', self.state);
                if (!isMutation) {
                    console.warn(`You should use a mutation to set ${key}`);
                    self.status = 'resting';
                }
                return true;
            }
        });
    }

    // Direct setState method to update the state
    setState(newState) {
        let self = this;
        console.log('setState called with:', newState);
        self.status = 'mutation';
        
        try {
            // Update each key individually to trigger the proxy
            if (newState) {
                Object.keys(newState).forEach(key => {
                    console.log(`Setting state key: ${key} to:`, newState[key]);
                    self.state[key] = newState[key];
                });
            }
            
            self.status = 'resting';
            return true;
        } catch (error) {
            console.error('setState error:', error);
            self.status = 'resting';
            return false;
        }
    }

    dispatch(actionKey, payload) {
        let self = this;
        if (typeof self.actions[actionKey] !== 'function') {
            console.error(`Action "${actionKey}" doesn't exist.`);
            return false;
        }
        console.groupCollapsed(`ACTION: ${actionKey}`);
        self.status = 'action';
        try {
            self.actions[actionKey](payload);
            console.groupEnd();
            return true;
        } catch (error) {
            console.error('Action error:', error);
            console.groupEnd();
            return false;
        }
    }

    commit(mutationKey, payload) {
        let self = this;
        if (typeof self.mutations[mutationKey] !== 'function') {
            console.error(`Mutation "${mutationKey}" doesn't exist`);
            return false;
        }
        self.status = 'mutation';
        
        try {
            // Apply mutation to get the new state
            const newState = self.mutations[mutationKey](self.state, payload);
            
            // If we have a new state object, update the entire state
            if (newState && typeof newState === 'object') {
                // Instead of updating individual keys, set all keys at once
                Object.keys(newState).forEach(key => {
                    if (self.state[key] !== newState[key]) {
                        console.log(`Setting state key: ${key} to:`, newState[key]);
                        self.state[key] = newState[key];
                    }
                });
            }
            
            self.status = 'resting';
            return true;
        } catch (error) {
            console.error('Mutation error:', error);
            self.status = 'resting';
            return false;
        }
    }   
}
